<template>
    <main
        :class="[
            'min-h-screen max-h-screen p-4 small_desktop:p-8 transition-all duration-200 relative overflow-auto',
            [hasEmailConfirmation ? 'pt-20 small_desktop:pt-[5.5rem]' : 'pt-36 small_desktop:pt-[7.5rem]'],
            { 'ml-20': navbarCollapse },
            { 'small_desktop:ml-64': !navbarCollapse },
            'bg-gray-200',
        ]"
    >
        <slot></slot>
    </main>
</template>

<script>
export default {
    name: 'YpMain',

    computed: {
        navbarCollapse() {
            return this.$store.getters['auth/user'] ? this.$store.getters['navbar/navbarCollapse'] : false;
        },

        hasEmailConfirmation() {
            return this.$store.getters['auth/hasEmailConfirmation'];
        },
    },
};
</script>
